export const AppointmentChip = ({
  type,
  icon,
  label,
  shortLabel,
  isSelected,
  onClick
}: {
  type: "WALK_IN" | "TELECONSULTATION";
  icon: React.ReactNode;
  label: string;
  shortLabel: string;
  isSelected: boolean;
  onClick: (e: React.MouseEvent, type: "WALK_IN" | "TELECONSULTATION") => void;
}) => {
  return (
    <button
      onClick={(e) => onClick(e, type)}
      className={`
        inline-flex items-center gap-2 px-4 py-2 rounded-full font-medium text-sm
        transition-all duration-200 ease-in-out
        border-2 cursor-pointer
        hover:shadow-md hover:scale-105
        max-sm:px-3 max-sm:py-1.5 max-sm:text-xs max-sm:gap-1.5
        ${isSelected
          ? 'bg-primary border-primary text-primary-foreground shadow-sm'
          : 'bg-white border-gray-300 text-gray-700 hover:border-primary hover:text-primary'
        }
      `}
    >
      <span className="flex-shrink-0">
        {icon}
      </span>
      <span className="max-sm:hidden whitespace-nowrap">
        {label}
      </span>
      <span className="sm:hidden whitespace-nowrap">
        {shortLabel}
      </span>
    </button>
  );
};
